module.exports = __webpack_public_path__ + "img/Google.4820ca8.png";